module.exports = __webpack_public_path__ + "img/122.2.d8e6c60e.png";